import React from 'react';

import { SegmentedControl } from '@reckon-web/segmented-control';

export type JobsOrTasks = 'jobs' | 'tasks';

const jobsOrTasksOptions: { label: string; value: JobsOrTasks }[] = [
  { label: 'Jobs', value: 'jobs' },
  { label: 'Tasks', value: 'tasks' },
];

export const JobsOrTasksToggle: React.FC<{
  jobsOrTasks: JobsOrTasks;
  testId?: string;
  setJobsOrTasks: (jobsOrTasks: JobsOrTasks) => void;
}> = ({ jobsOrTasks, setJobsOrTasks, testId = `jobs-or-tasks` }) => (
  <SegmentedControl
    options={jobsOrTasksOptions}
    value={jobsOrTasks}
    onChange={setJobsOrTasks}
    data-testid={testId}
  />
);
